import { render, staticRenderFns } from "./ResetForm.vue?vue&type=template&id=0c35e3d0"
import script from "./ResetForm.vue?vue&type=script&lang=js"
export * from "./ResetForm.vue?vue&type=script&lang=js"
import style0 from "./ResetForm.vue?vue&type=style&index=0&id=0c35e3d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports